import { handleActions } from 'redux-actions';
import immutable from 'object-path-immutable';
import * as actions from './actions';

const defaultState = {
  form: {
    title: '',
    format: '',
    is_locked: false,
    from: null,
    to: null,
    created_date: null,
    sent_date: null,
    greeting_text: '',
    thanks_text: '',
    template: null,

    photo: null,
    audio: null,
    video: null,

    configured_date: null,
    is_need_convert_video: false,
  },
  uploadedMedia: null,

  scannedSticker: null,

  // Save sticker
  isStickerSaving: false,
  stickerSaveError: null,
  stickerSaveSuccess: false,
  savedSticker: null,

  // additional form helpers (dont sent on server)
  formTemp: {
    template_group: null,
    text_template: null,
    text_template_group: null
  },

  // Congratulations
  // showCongratulations: false,
  // congratulationsSticker: null,

  // Create after sign in
  createStickerAfterSignIn: false,
};

const reducer = handleActions(
  new Map([
    [actions.setForm,
      (state, action) => immutable.set(state, 'form', action.payload)],

    [actions.updateForm,
      (state, action) => (immutable as any).merge(state, 'form', action.payload)],

    [actions.setFormat,
      (state, action) => immutable.set(state, 'form.format', action.payload)],

    [actions.setTheme,
      (state, action) => immutable.set(state, 'form.template', action.payload?.id)],

    [actions.setThemeGroup,
      (state, action) => immutable.set(state, 'formTemp.template_group', action.payload?.id)],

    [actions.setTextTemplatesGroup,
      (state, action) => immutable.set(state, 'formTemp.text_template_group', action.payload?.id)],

    [actions.setTextTemplate,
      (state, action) => {
        const { template } = action.payload;
        return immutable(state)
          .set('formTemp.text_template', template.id)
          .set('form.greeting_text', template.text)
          .value();
      }],

    [actions.setText,
      (state, action) => {
        return immutable(state)
          .set('form.greeting_text', action.payload)
          .set('formTemp.text_template', null)
          .value()
      }],

    [actions.setVideo,
      (state, action) => immutable.set(state, 'form.video', action.payload)],

    [actions.setPhoto,
      (state, action) => immutable.set(state, 'form.photo', action.payload)],

    [actions.setAudio,
      (state, action) => immutable.set(state, 'form.audio', action.payload)],

    [actions.resetForm,
      (state, action) => ({ ...defaultState })],

    // Save sticker with qr
    [actions.saveStickerItemRequest,
      (state, action) => ({
        ...state,
        isStickerSaving: true,
        stickerSaveError: null,
        stickerSaveSuccess: false,
      })],
    [actions.saveStickerItemSuccess,
      (state, action) => ({
        ...state,
        isStickerSaving: false,
        stickerSaveError: null,
        stickerSaveSuccess: true,
        savedSticker: action.payload,
      })],
    [actions.saveStickerItemFailed,
      (state, action) => ({
        ...state,
        isStickerSaving: false,
        stickerSaveError: action.payload,
        stickerSaveSuccess: false,
      })],
    [actions.setPreparedMedia,
      (state, action) => ({ ...state, uploadedMedia: action.payload })],

    // Congratulations modal
    // [actions.showCongratulations,
    //   (state, action) => ({
    //     ...state,
    //     showCongratulations: true,
    //     congratulationsSticker: action.payload
    //   })],
    // [actions.hideCongratulations,
    //   (state, action) => ({
    //     ...state,
    //     showCongratulations: false,
    //     congratulationsSticker: null
    //   })],

    // Create sticker after sign in
    [actions.setCreateStickerOnSignInFlag,
      (state, action) => ({ ...state, createStickerAfterSignIn: action.payload })],


    [actions.setScannedStickerItem,
      (state, action) => ({ ...state, scannedSticker: action.payload, scannedStickerLoading: false })],
    
    [actions.setScannedStickerItemRequest,
      (state, action) => ({ ...state, scannedStickerLoading: true })],

    [actions.restoreForm,
      (state, action) => {
        const { form, formTemp, scannedSticker } = action.payload;
        return immutable(state)
          .set('form', form)
          .set('formTemp', formTemp)
          .set('scannedSticker', scannedSticker)
          .value()
      }],

  ]),
  defaultState
);

export default reducer;



// WEBPACK FOOTER //
// ./src/app/modules/stickers/store/create-llama/reducer.ts